import React from 'react';
import { map } from 'lodash';
import { getLabel } from 'utils/getLabel';
import classNames from 'classnames';

// local dependencies
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { sidebarNav as SidebarNav } from 'ui/views/widgets/sidebarNav';
 *
 * // render
 * <SidebarNav propName='propValue'/>
 */
export const sidebarNav = ( { tabs, selectedTab, onTabChange } ) => {
    return (
        <div className='ui-sidebar-nav'>
            {
                map( tabs, tab => {
                    const tabName = tab.name;

                    const tabClassName = classNames( 'ui-sidebar-nav__tab', {
                        'ui-sidebar-nav__tab--selected': selectedTab === tabName
                    } );

                    const tabTitleClassName = classNames( 'ui-sidebar-nav__tab__title', {
                        'ui-sidebar-nav__tab__title--selected': selectedTab === tabName
                    } );

                    return (
                        <div
                            key={ tabName }
                            className={ tabClassName }
                            onClick={ () => onTabChange( tabName ) }
                        >
                            <div className='ui-sidebar-nav__tab__icon'>
                                <Icon id={ tabName } fill={ selectedTab === tabName ? '#003e7b' : '#000000' } />
                            </div>
                            <div className={ tabTitleClassName }>
                                { getLabel( tab.title ) }
                            </div>
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
sidebarNav.displayName = 'sidebarNav';

// set default props
sidebarNav.defaultProps = {};

// prop types
sidebarNav.propTypes = {};
